import { getSystemWorkbenchUrl, WorkbenchTab } from 'utils/RouteHelper';

/**
 * Formats an alert timestamp.
 * @param formatDate - The function to format the date.
 * @param formatTime - The function to format the time.
 * @param date - The date to format.
 * @returns The formatted timestamp.
 */
export function formatAlertTimestamp(
    formatDate: (date: Date) => string,
    formatTime: (date: Date) => string,
    date: Date,
): string {
    return `Created ${formatDate(date)} at ${formatTime(date)}`;
}

/**
 * Returns the Workbench URL for an alert.
 * @param hierarchy - The hierarchy of the alert.
 * @param alertId - The ID of the alert.
 * @returns The Workbench URL for the alert.
 */
export function getWorkbenchUrl(
    hierarchy: Array<{ HierarchyId: string; HierarchyType: string } | undefined>,
    alertId: string,
): string {
    // System is always the first item in the hierarchy
    const systemId = hierarchy[0]?.HierarchyId;
    if (!systemId) {
        return '';
    }
    return getSystemWorkbenchUrl(systemId, WorkbenchTab.Trend, { alertId });
}
